import { APIConfiguration } from '@savgroup-front-common/configuration';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants/src/shared';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/src/shared/supportedMethods';
import {
  BackResponse,
  BackResponseFailure,
  TechnicalInterventionStatus,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.repairer}technicalIntervention/states/${COMMON_QUERY_PARAMS.SELLER_ID}`;

export interface GetTechnicalInterventionStatesBySellerQueryPayload {
  sellerId: string;
}

export interface TechnicalInterventionState {
  state: TechnicalInterventionStatus;
  displayState: TechnicalInterventionStatus;
}

export const getTechnicalInterventionStatesBySellerQuery = async ({
  sellerId,
}: GetTechnicalInterventionStatesBySellerQueryPayload): Promise<
  BackResponse<TechnicalInterventionState[]> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    const response: BackResponse<TechnicalInterventionState[]> = await apiCall(
      url,
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
